import type { WidgetCatalogueEntry } from './types';

// The widget catalogue doesn't change while the app is open, so one fetch serves every editor.
let catalogue: Promise<WidgetCatalogueEntry[]> | null = null;

export function loadCatalogue(
  authFetch: (path: string, init?: RequestInit) => Promise<Response>,
): Promise<WidgetCatalogueEntry[]> {
  if (!catalogue) {
    catalogue = authFetch('/layout/widgets')
      .then(r => (r.ok ? r.json() : Promise.reject(new Error('Failed to load widgets'))))
      .catch(err => { catalogue = null; throw err; });
  }
  return catalogue;
}

export async function layoutError(res: Response, fallback: string): Promise<string> {
  try {
    const body = await res.json();
    return typeof body?.detail === 'string' ? body.detail : fallback;
  } catch {
    return fallback;
  }
}
